import React, { useState, useEffect } from "react";
import { Col, Row, Card, Spin } from "antd";
import {
    InfoCircleOutlined,
    ExclamationCircleOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
} from "@ant-design/icons";
const ErpReportSummary = (props) => {
    const [summaryData, setSummaryData] = useState({
        data: props.data,
        loading: false,
    });
    useEffect(() => {
        setSummaryData({
            data: props.data,
            loading: false,
        });
    }, [props]);
    const formatNumber = (number, currency) => {
        number = parseFloat(number);
        let parts = number.toFixed(2).toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        let formattedAmount = parts.join(",")
        switch (currency?.toLowerCase()) {
            case "usd":
                return `${formattedAmount} $`;
            case "try":
            case "tl":
                return `${formattedAmount} ₺`;
            case "eur":
                return `${formattedAmount} €`;
            case "aud":
                return `${formattedAmount} AU$`;
            case "chf":
                return `${formattedAmount} CHF`;
            case "cny":
            case "jpy":
                return `${formattedAmount} ¥`;
            case "gbp":
                return `${formattedAmount} £`;
            case "dkk":
                return `${formattedAmount} DKK`;
            default:
                return `${formattedAmount} ${currency?.toUpperCase() || ""}`;
        }
    };


    return (
        <Row id="summaryArea" style={{ ...props.style }}>
            <Col span={24}>
                <Card
                    hoverable
                    style={{
                        borderRadius: "10px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        background: "linear-gradient(to right, #e3f2fd, #ffffff)",
                    }}
                    bodyStyle={{ padding: 0 }}
                >
                    {props.loading ?
                        <Row justify="center" align="middle" style={{ height: "130px" }}>
                            <Spin style={{ margin: 5 }} />
                        </Row> :
                        <Row justify="center">
                            <Col xs={24} style={{ textAlign: 'right', color: "#777", paddingTop: 8, paddingRight: 40, marginBottom: -5, fontSize: 12 }}>
                                <p>Varsayılan olarak son 6 ayın verisi raporlanır.</p>
                            </Col>
                            <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                    <p>
                                        <InfoCircleOutlined
                                            style={{
                                                color: "blue",
                                                fontSize: "150%",
                                                backgroundColor: "#d6ebf9",
                                                borderRadius: "50%",
                                                padding: "8px",
                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                            }}
                                        />
                                    </p>
                                    <h4 style={{ fontWeight: "600", color: "#333" }}>Aktarılmamış</h4>
                                </div>
                                <hr style={{ width: "60%", margin: "auto", marginBottom: 10 }} />
                                {summaryData.data.totals.map((item, index) => (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                        <p>Adet: <span style={{ fontWeight: "500" }}>{item.count}</span></p>
                                        <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(item.amount, item.currencyCode)}</span></p>
                                    </div>
                                ))}
                            </Col>
                            <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                    <p>
                                        <CheckCircleOutlined
                                            style={{
                                                color: "green",
                                                fontSize: "150%",
                                                backgroundColor: "#E8F5E9",
                                                borderRadius: "50%",
                                                padding: "8px",
                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                            }}
                                        />
                                    </p>
                                    <h4 style={{ fontWeight: "600", color: "#333" }}>Başarılı</h4>
                                </div>
                                <hr style={{ width: "60%", margin: "auto", marginBottom: 10 }} />
                                {summaryData.data.successes.map((item, index) => (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                        <p>Adet: <span style={{ fontWeight: "500" }}>{item.count}</span></p>
                                        <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(item.amount, item.currencyCode)}</span></p>
                                    </div>
                                ))}
                            </Col>
                            <Col xs={24} md={12} lg={6} style={{ textAlign: "center" }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                    <p>
                                        <ClockCircleOutlined
                                            style={{
                                                color: "orange",
                                                fontSize: "150%",
                                                backgroundColor: "#FFEBEE",
                                                borderRadius: "50%",
                                                padding: "8px",
                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                            }}
                                        />
                                    </p>
                                    <h4 style={{ fontWeight: "600", color: "#333" }}>Aktarılıyor</h4>
                                </div>
                                <hr style={{ width: "60%", margin: "auto", marginBottom: 10 }} />
                                {summaryData.data.transferables.map((item, index) => (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                        <p>Adet: <span style={{ fontWeight: "500" }}>{item.count}</span></p>
                                        <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(item.amount, item.currencyCode)}</span></p>
                                    </div>
                                ))}
                            </Col>
                            <Col xs={24} md={12} lg={6} style={{ textAlign: "center", marginBottom: 5 }}>
                                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                    <p>
                                        <ExclamationCircleOutlined
                                            style={{
                                                color: "red",
                                                fontSize: "150%",
                                                backgroundColor: "#FFEBEE",
                                                borderRadius: "50%",
                                                padding: "8px",
                                                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)"
                                            }}
                                        />
                                    </p>
                                    <h4 style={{ fontWeight: "600", color: "#333" }}>Hatalı</h4>
                                </div>
                                <hr style={{ width: "60%", margin: "auto", marginBottom: 10 }} />
                                {summaryData.data.errors.map((item, index) => (
                                    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "15px", color: "#777" }}>
                                        <p>Adet: <span style={{ fontWeight: "500" }}>{item.count}</span></p>
                                        <p>Tutar: <span style={{ fontWeight: "500" }}>{formatNumber(item.amount, item.currencyCode)}</span></p>
                                    </div>
                                ))}
                            </Col>
                        </Row>
                    }
                </Card>
            </Col>
        </Row>
    );
};
function updateList(list, item) {
    const index = list.findIndex(t => t.currencyCode === (item.currencyCode ?? item.currency));
    if (index !== -1) {
        list[index].amount += item.amount;
        list[index].count += 1;
    } else {
        list.push({ amount: item.amount, count: 1, currencyCode: (item.currencyCode ?? item.currency)});
    }
}
export function SummaryDataList(response) {
    let totals = [];
    let successes = [];
    let transferables = [];
    let errors = [];
    response.forEach(
        (item) => {
            switch (item.erpTransferStatusId) {
                case 0:
                    updateList(totals, item);
                    break;
                case 1:
                    updateList(successes, item);
                    break;
                case 2:
                    updateList(transferables, item);
                    break;
                case 3:
                    updateList(errors, item);
                    break;
                default:
                    break;
            }
        }
    );
    return ({
        totals: totals,
        successes: successes,
        errors: errors,
        transferables: transferables
    });
}
export default ErpReportSummary;